/**
 * Created by zjs on 2017/09/28
 */
import * as types from './mutation-types'

export default {
    /**
     * 设置页面表单中的搜索数据
     */
    [types.SET_PAGE_SEARCH_FORM] (state, searchForm) {
        state.searchForm[searchForm.route] = Object.assign({}, searchForm) 
    },
    /**
     * 设置复制单据的详情
     */
    [types.SET_COPY_INFO] (state, info) {
        state.copyInfo = info
    }
}